import NavigationSPA from '../app/components/NavigationSPA'
import { useTranslation } from 'react-i18next'

export default function TutorialVideosPage() {
  const { t } = useTranslation('tutorialVideos')

  return (
    <div className="min-h-screen bg-gray-100">
      <NavigationSPA />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              {t('pageTitle', 'Tutorial Videos')}
            </h1>
            <p className="mt-2 text-gray-600">
              {t('pageDescription', 'Learn how to use SmartProbe with our comprehensive video tutorials')}
            </p>
          </div>

          {/* Video Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Video 1: SmartProbe Set Up Tutorial */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/WFRFPraDB3I"
                  title="SmartProbe Set Up Tutorial"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('video1Title', 'SmartProbe Set Up Tutorial')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('video1Desc', 'Learn how to set up your SmartProbe device')}
                </p>
              </div>
            </div>

            {/* Video 2: SmartProbe Mobile App Walkthrough */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/Ic7bxvvWn4w"
                  title="SmartProbe Mobile App Walkthrough"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('video2Title', 'SmartProbe Mobile App Walkthrough')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('video2Desc', 'Navigate the SmartProbe mobile application')}
                </p>
              </div>
            </div>

            {/* Video 3: SmartProbe Website Walkthrough */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/U0ulR-WTnwk"
                  title="SmartProbe Website Walkthrough"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('video3Title', 'SmartProbe Website Walkthrough')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('video3Desc', 'Explore the SmartProbe website application')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
